export const PRESETS = [
  {
    id: 'revenue-focused',
    label: 'Revenue Focused',
    metricIds: [
      'totalRevenue',
      'revenueTimeSeries',
      'creditsPurchasedVsSpent',
      'avgRevenuePerCompany',
      'topCompaniesBySpend',
      'employerFunnel',
    ],
  },
  {
    id: 'growth-focused',
    label: 'Growth Focused',
    metricIds: [
      'totalSignups',
      'employerSignups',
      'candidateSignups',
      'signupVelocity',
      'assessmentCompletion',
      'employerFunnel',
      'candidateFunnel',
    ],
  },
  {
    id: 'ad-performance',
    label: 'Ad Performance',
    // Phase 21 attribution metrics not yet available; using available proxies
    metricIds: [
      'employerSignups',
      'totalRevenue',
      'signupVelocity',
      'employerFunnel',
    ],
  },
];
